// @ts-nocheck
/* eslint-disable */
import Scene from "~/scene";
import { whereami } from "./util/providers/poiagg";
import SceneCoords from "~/scene/common/coords";
import { store } from "~/state/store";

interface IWhereamiData {
	coords: SceneCoords;
	gpsCoords: SceneCoords;
	id: number;
	label: string;
	source: string;
}

/**
 * @param coords
 * @param forceZoom je-li zadaný, metoda nevezme zoom z aktuální mapy, ale použije se ten zadaný
 */
export function getLocation(coords: SceneCoords, forceZoom?: number): Promise<IWhereamiData> {
	coords = coords.clone();
	return new Promise((resolve, reject) => {
		var data = {
			lon: coords.toWGS84()[0],
			lat: coords.toWGS84()[1],
			zoom: forceZoom || store.getState().map.zoom,
		}

		whereami(data.lon, data.lat, data.zoom).then(function(response) {
			var status = response.status;
			//var data = "data" in response ? JSON.parse(response.data) : {};
			if (!status || status.toString().charAt(0) != "2") {
				reject(response);
				return;
			}

			var poi = response.poi;

			var result = {
				coords: Scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat),
				gpsCoords: Scene.coordsFromWGS84(data.lon, data.lat),
				source: poi.source,
				id: poi.id,
				label: poi.title
			};
			if (result.source == "coor") {
				result.id = result.coords.toWGS84().join(",");
				result.label = result.coords.toWGS84(2).reverse().join(", ");
			}

			resolve(result);
		}, function(response) {
			reject(response);
		});
	});
}

async function openLocationFromEvent(e: MouseEvent | KeyboardEvent) {
	var coords = await Scene.coordsFromEventAsync(e);

	getLocation(coords).then(function(data) {
		Mapy.getComponent("detail").setState({
			source: data.source,
			id: data.id,
			coords: coords,
			gpsCoords: data.gpsCoords,
			manual: true,
			show: false
		});

		Mapy.getComponent("history").save();
	}, () => {});
}

export function handleClick(e: MouseEvent | KeyboardEvent) {
	if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) {
		openLocationFromEvent(e);
		return true;
	}

	return false;
}
